
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[[...pathArray]]",
      function () {
        return require("private-next-pages/[[...pathArray]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[[...pathArray]]"])
      });
    }
  